// extracted by mini-css-extract-plugin
export default {"link":"Link_link__3zjsw","link__body":"Link_link__body__6W3c5"};